<template>
    <div class="text-center">

        <template v-for="(i, idx) in total" :key="`splide-custom-pagination-dot-${idx}`">
            <!-- {{idx}} -->
            <span class="dot first:ml-0 last:mr-0 mx-2px transition-all transform duration-300" :class="{ active: value == idx }" @click="onChange(idx)"></span>
        </template>
    </div>
</template>

<script>
export default {
    name: "SplideCustomPagination",
    props: {
        total: {
            type: Number,
            default: 0,
        },
        value: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        onChange: function (idx) {
            if (this.disabled) {
                return;
            }
            this.$emit("change", idx);
        },
    },
};
</script>

<style lang="scss" scoped>
.dot {
    height: 6px;
    width: 6px;
    background-color: #cfd3dc;
    border-radius: 50%;
    display: inline-block;

    &.active {
        width: 13.5px;
        border-radius: 100px;
        background-image: linear-gradient(to right, #1c2c73 0%, #016cb8 100%);
    }
}
</style>
